import md5 from 'md5';

/**
 * creates a hash based on bucketKey then converts the hash into a random number between 0 and 1
 *  - ALWAYS returns the same number given the same bucketKey
 * @param {string} bucketKey combination of userId and experimentId
 */
export const roll = (bucketKey: string): number => {
  if (!bucketKey) {
    return null;
  }

  const hash = md5(bucketKey);
  // convert hash into base 16 number (since the hash is a hex value)
  // divide by the hash size of md5 (2^128) to get a number between 0 and 1
  return parseInt(hash, 16) / 2 ** 128;
};

export default {
  roll
};
